module.exports = __webpack_public_path__ + "static/media/python.182e9823.png";